module.exports = __webpack_public_path__ + "static/media/Kimi.30d36926.png";